/** @jsx jsx */
import { useContext } from 'react'
import { jsx, Flex, Text } from 'theme-ui'
import { QuestionStepContext } from '../../context/QuestionStepContext'
import LogoHeader from './LogoHeader'
import { CfnButton } from '../common/Buttons'
import { parseAnswers } from '../strategy-builder/QuestionCard'
import { useMutation } from '@apollo/client'
import SUBMIT_ANSWERS from '../../apollo/queries/SUBMIT_ANSWERS'
import GET_QUESTIONS from '../../apollo/queries/GET_QUESTIONS'
import GET_PERSONAS from '../../apollo/queries/GET_PERSONAS'
import { useBreakpoint } from '../../utils/useWindowWidth'
import GET_TEMPLATE_OVERVIEW, {
  TEMPLATE_CATEGORY,
} from '../../apollo/queries/GET_TEMPLATE_OVERVIEW'
import { navigate } from 'gatsby'
import { ArrowLeft } from '../../icons'
import { cleanUpIsHide } from '../common/form/FormikHelper'

const QuestionStepHeader = () => {
  const {
    template,
    valuesFromFormik,
    exitingStrategyBuilder,
    setExitingStrategyBuilder,
    questionProgressStep,
    totalQuestionProgressSteps,
    stepheaderTitle,
  } = useContext(QuestionStepContext)
  const breakpoint = useBreakpoint()
  const isDesktop = breakpoint === 'desktop'

  const [submitAnswers] = useMutation(SUBMIT_ANSWERS, {
    refetchQueries: [
      { query: GET_QUESTIONS, variables: { templateName: template?.title } },
      { query: GET_PERSONAS, variables: {} },
      {
        query: GET_TEMPLATE_OVERVIEW,
        variables: { templateCategory: TEMPLATE_CATEGORY.STRATEGY_BUILDER },
      },
    ],
    awaitRefetchQueries: true,
  })

  const saveAndExit = async (includeNavigation = true) => {
    setExitingStrategyBuilder(true)
    cleanUpIsHide(valuesFromFormik)
    const answers = parseAnswers(valuesFromFormik, template)

    const request = {
      currentQuestionNumber: template.currentStep + 1,
      templateId: template.id,
      templateStatus: template.templateStatus,
      questionAndAnswers: answers,
      currentSubstepNumber: questionProgressStep,
      currentSubstepTotalNumber: totalQuestionProgressSteps,
    }
    await submitAnswers({ variables: { request } })
    includeNavigation && navigate('/app/StrategyBuilder')

    setExitingStrategyBuilder(false)
  }

  return (
    <Flex
      sx={{
        backgroundColor: 'primary',
        flexDirection: 'column',
        pt: 1,
      }}
    >
      <LogoHeader onClick={() => saveAndExit(false)} />
      <Flex
        sx={{
          alignItems: 'center',
          justifyContent: 'center',
          px: 5,
          height: isDesktop ? 50 : 150,
          flexWrap: 'wrap-reverse',
        }}
      >
        <Flex
          sx={{
            alignItem: 'center',
            mb: 20,
          }}
        >
          <Text variant="h4" as="h4" color="white">
            {stepheaderTitle}
          </Text>
        </Flex>
        <Flex
          sx={{
            position: isDesktop ? 'absolute' : 'static',
            width: '100%',
            right: 0,
            mt: 0,
            ml: 10,
            mr: 10,
            mb: 30,
          }}
        >
          <CfnButton
            data-automation-id="save-and-or-exit-button"
            onClick={async () => await saveAndExit()}
            buttonStyle="secondary"
            color="forest"
            float="right"
            size="small"
            leftIcon={<ArrowLeft color="#93d3f3" />}
            sx={{
              borderColor: '#92D3F3',
              color: '#fff',
              margin: '0px 10px 0px auto',
            }}
          >
            {template?.isSummaryPage
              ? 'Exit'
              : exitingStrategyBuilder
              ? 'Saving'
              : 'Save & Exit'}
          </CfnButton>
        </Flex>
      </Flex>
    </Flex>
  )
}

export default QuestionStepHeader
